export const storage = {
    private: 'private',
    public: 'public',

    reports_folder: 'reports',
    company_logo_folder: 'company-logo',
}

export const company_table = {
    table_name: 'tbl_company',
    company_id: 'company_id',
    company_name: 'company_name',
    company_logo: 'company_logo',

    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};

export const report_data_table = {
    table_name: 'tbl_report_data',
    report_id: 'report_id',
    company_id: 'company_id',
    policy_no: 'policy_no',
    report_name: 'report_name',
    number_of_pages: 'number_of_pages',
    assigned_by: 'assigned_by',

    assigned_to: 'assigned_to',
    assigned_at: 'assigned_at',
    completed_at: 'completed_at',
    status: 'status',

    assigned_to_reviewer: 'assigned_to_reviewer',
    assigned_at_reviewer: 'assigned_at_reviewer',
    completed_at_reviewer: 'completed_at_reviewer',
    status_reviewer: 'status_reviewer',


    hold_at: 'hold_at',
    hold_reason: 'hold_reason',
    hold_by: 'hold_by',
    report_path: 'report_path',
    report_type: 'report_type',
    report_size: 'report_size',
    page_count: 'page_count',
    case_id: 'case_id',
    doc_type: 'doc_type',
    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};

export const user_table = {
    table_name: 'tbl_user',
    user_id: 'user_id',
    username: 'username',
    password_hash: 'password_hash',
    email: 'email',
    created_at: 'created_at',
    updated_at: 'updated_at',
    uuid: 'uuid',
    user_role: 'user_role'
}

export const report_insurer_details_table = {
    table_name: 'tbl_report_insurer_details',
    insurer_id: 'insurer_id',
    report_id: 'report_id',
    case_id: 'case_id',

    medical_summary_code: 'medical_summary_code',
    policy_no: 'policy_no',
    name_of_insured: 'name_of_insured',
    age: 'age',
    gender: 'gender',
    height_cm: 'height_cm',
    weight_kg: 'weight_kg',
    bmi: 'bmi',
    girth_cm: 'girth_cm',
    pulse: 'pulse',
    is_photo_id_submitted: 'is_photo_id_submitted',
    photo_id_proof: 'photo_id_proof',
    photograph_available: 'photograph_available',
    photograph_matches_id: 'photograph_matches_id',
    name_matches_with_id_proof: 'name_matches_with_id_proof',
    smoker: 'smoker',
    alcohol: 'alcohol',
    narcotics: 'narcotics',
    family_medical_history: 'family_medical_history',

    systolic1: 'systolic1',
    systolic2: 'systolic2',
    systolic3: 'systolic3',
    diastolic1: 'diastolic1',
    diastolic2: 'diastolic2',
    diastolic3: 'diastolic3',

    geotag_info: 'geotag_info',


    id_proof_number: 'id_proof_number',
    dob: 'dob',
    father_age: 'father_age',
    mother_age: 'mother_age',
    sibling_age: 'sibling_age',
    technician_name: 'technician_name',
    qualification: 'qualification',
    date_of_exam: 'date_of_exam',

    raw_data: 'raw_data',

    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};

export const report_test_details_table = {
    table_name: 'tbl_report_test_details',
    test_id: 'test_id',
    report_id: 'report_id',
    case_id: 'case_id',

    lab_report: 'lab_report',
    annotator_data: 'annotator_data',
    reviewer_data: 'reviewer_data',

    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};


export const ecg_table = {
    table_name: 'tbl_ecg_test_details',
    ecg_id: 'ecg_id',
    report_id: 'report_id',
    case_id: 'case_id',
    policy_no: 'policy_no',
    proposal_no: 'proposal_no',
    speed: 'speed',
    voltage: 'voltage',
    rhythm: 'rhythm',
    heart_rate: 'heart_rate',
    p_wave: 'p_wave',
    pr: 'pr',
    qrs: 'qrs',
    qt_interval: 'qt_interval',
    test_date: 'test_date',
    dc_name: 'dc_name',
    reported_by_dc: 'reported_by_dc',
    final_decision_of_cmo: 'final_decision_of_cmo',
    comments_of_cmo: 'comments_of_cmo',

    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};

export const tmt_table = {
    table_name: 'tbl_tmt_test_details',
    tmt_id: 'tmt_id',
    report_id: 'report_id',
    case_id: 'case_id',
    policy_no: 'policy_no',
    proposal_no: 'proposal_no',
    mechanism: 'mechanism',
    st_t_changes: 'st_t_changes',
    height: 'height',
    weight: 'weight',
    test_date: 'test_date',
    total_exercise_time: 'total_exercise_time',
    maximum_heart_rate: 'maximum_heart_rate',
    heart_rate_achieved_each_stage: 'heart_rate_achieved_each_stage',
    maximum_systolic_pressure: 'maximum_systolic_pressure',
    maximum_diastolic_pressure: 'maximum_diastolic_pressure',
    met_score_achieved: 'met_score_achieved',
    peak_product: 'peak_product',
    test_time: 'test_time',
    dc_name: 'dc_name',
    reported_by_dc: 'reported_by_dc',
    summary: 'summary',
    final_decision_of_cmo: 'final_decision_of_cmo',
    comments_of_cmo: 'comments_of_cmo',

    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};

export const case_table = {
    table_name: 'tbl_case',
    case_id: 'case_id',
    case_name: 'case_name',

    assigned_to: 'assigned_to',
    assigned_at: 'assigned_at',
    completed_at: 'completed_at',
    status: 'status',

    assigned_to_reviewer: 'assigned_to_reviewer',
    assigned_at_reviewer: 'assigned_at_reviewer',
    completed_at_reviewer: 'completed_at_reviewer',
    status_reviewer: 'status_reviewer',

    company_id: 'company_id',
    assigned_by: 'assigned_by',
    hold_at: 'hold_at',
    hold_reason: 'hold_reason',
    hold_by: 'hold_by',
    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    payload: 'payload',
    revisit: 'revisit',
    reason_to_confirm: 'reason_to_confirm',

    is_deleted: 'is_deleted'
};


export const app_settings_table = {
    table_name: 'tbl_app_settings',
    key: 'key',           // dotted, see constants/app-settings.ts AppSettingKey
    value: 'value',       // jsonb
    description: 'description',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
};

export const ftp_report_issue_table = {
    table_name: 'tbl_ftp_report_issue',
    id: 'id',
    report_name: 'report_name',
    reason: 'reason',
    status: 'status',
    report_type: 'report_type',
    report_size: 'report_size',

    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};

export const extra_info_table = {
    table_name: 'extra_info',
    id: 'id',
    report_id: 'report_id',
    case_id: 'case_id',
    raw_data: 'raw_data',
    annotator_data: 'annotator_data',
    reviewer_data: 'reviewer_data',
    created_at: 'created_at',
    created_by: 'created_by',
    updated_at: 'updated_at',
    updated_by: 'updated_by',
    is_deleted: 'is_deleted'
};

export const reviewer_finalize_history_table = {
    table_name: 'tbl_reviewer_finalize_history',
    history_id: 'history_id',
    case_id: 'case_id',
    attempt_no: 'attempt_no',
    finalized_at: 'finalized_at',
    status: 'status',
}
